module.exports = __webpack_public_path__ + "static/media/logo-new-yellow.e6c18fef.svg";